$(document).ready(function () {  
  
    $('.cdk-product .product-media-modal .product-media-modal__content').slick({
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll:1,
      prevArrow: '<button class="slide-arrow prev-arrow"><svg width="25px" height="25px" viewBox="-2 0 20 20" version="1.1" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <g id="Free-Icons" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"> <g transform="translate(-825.000000, -674.000000)" id="Group" stroke="#01ABCC" stroke-width="1.5"> <g transform="translate(819.000000, 672.000000)" id="Shape"> <polyline points="17.0011615 3 7 12.0021033 17.0011615 21.0042067"> </polyline> </g> </g> </g> </g></svg></button>',
      nextArrow: '<button class="slide-arrow next-arrow"><svg width="25px" height="25px" viewBox="-6 0 20 20" version="1.1" fill="#000000" stroke="#000000" style="&#10;"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <g id="Free-Icons" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"> <g transform="translate(-751.000000, -674.000000)" id="Group" stroke="#01ABCC" stroke-width="1.5"> <g transform="translate(745.000000, 672.000000)" id="Shape"> <polyline points="7 3 17.0011615 12.0021033 7 21.0042067"> </polyline> </g> </g> </g> </g></svg></button>',
      adaptiveHeight: true
    });
  
    function reccentCartSlider(){
      $('.cdk-cartSlider').slick({
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll:1,
        prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M0.292892 8.7071C-0.0976296 8.31658 -0.0976295 7.68341 0.292893 7.29289L6.65685 0.928929C7.04738 0.538404 7.68054 0.538404 8.07107 0.928929C8.46159 1.31945 8.46159 1.95262 8.07107 2.34314L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.7071ZM48 9L1 9L1 7L48 7L48 9Z" fill="#369FC6"/></svg></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M47.7071 8.7071C48.0976 8.31658 48.0976 7.68341 47.7071 7.29289L41.3431 0.928929C40.9526 0.538404 40.3195 0.538404 39.9289 0.928929C39.5384 1.31945 39.5384 1.95262 39.9289 2.34314L45.5858 8L39.9289 13.6569C39.5384 14.0474 39.5384 14.6805 39.9289 15.0711C40.3195 15.4616 40.9526 15.4616 41.3431 15.0711L47.7071 8.7071ZM8.74228e-08 9L47 9L47 7L-8.74228e-08 7L8.74228e-08 9Z" fill="#369FC6"/></svg></button>'
      
      });
    }
    function youMayLikeCartSlider(){
      $('.cdk-slider').slick({
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll:1,
        prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M0.292892 8.7071C-0.0976296 8.31658 -0.0976295 7.68341 0.292893 7.29289L6.65685 0.928929C7.04738 0.538404 7.68054 0.538404 8.07107 0.928929C8.46159 1.31945 8.46159 1.95262 8.07107 2.34314L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.7071ZM48 9L1 9L1 7L48 7L48 9Z" fill="#369FC6"/></svg></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M47.7071 8.7071C48.0976 8.31658 48.0976 7.68341 47.7071 7.29289L41.3431 0.928929C40.9526 0.538404 40.3195 0.538404 39.9289 0.928929C39.5384 1.31945 39.5384 1.95262 39.9289 2.34314L45.5858 8L39.9289 13.6569C39.5384 14.0474 39.5384 14.6805 39.9289 15.0711C40.3195 15.4616 40.9526 15.4616 41.3431 15.0711L47.7071 8.7071ZM8.74228e-08 9L47 9L47 7L-8.74228e-08 7L8.74228e-08 9Z" fill="#369FC6"/></svg></button>'
      
      });
    }
    function customTabSilder(){
      $(".cdk_tab_content.active").flickity({
        wrapAround: true,
        pageDots: true,
        cellAlign: 'left',
        initialIndex: 0,
        accessibility: true, 
        prevNextButtons: true,
        freeScroll: true,
        autoPlay: false
      });
    } 
    function collectionTabs(){
      $('.cdk-slick-slider').slick({
        dots: false,
        infinite: true,
        centerMode: true,
        centerPadding: '150px',
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M0.292892 8.7071C-0.0976296 8.31658 -0.0976295 7.68341 0.292893 7.29289L6.65685 0.928929C7.04738 0.538404 7.68054 0.538404 8.07107 0.928929C8.46159 1.31945 8.46159 1.95262 8.07107 2.34314L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.7071ZM48 9L1 9L1 7L48 7L48 9Z" fill="#369FC6"/></svg></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M47.7071 8.7071C48.0976 8.31658 48.0976 7.68341 47.7071 7.29289L41.3431 0.928929C40.9526 0.538404 40.3195 0.538404 39.9289 0.928929C39.5384 1.31945 39.5384 1.95262 39.9289 2.34314L45.5858 8L39.9289 13.6569C39.5384 14.0474 39.5384 14.6805 39.9289 15.0711C40.3195 15.4616 40.9526 15.4616 41.3431 15.0711L47.7071 8.7071ZM8.74228e-08 9L47 9L47 7L-8.74228e-08 7L8.74228e-08 9Z" fill="#369FC6"/></svg></button>',
        responsive: [
          {
            breakpoint: 1180,
            settings: {
              centerMode: true,
              centerPadding: '200px',
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 1100,
            settings: {
              centerMode: true,
              centerPadding: '150px',
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 991,
            settings: {
              centerMode: true,
              centerPadding: '200px',
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              dots:true,
              arrows: false
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '52.5px',
              dots:true,
              arrows: false 
            }
          }
        ]
      });
    }
    // function wholeSaleCollectionTabsilder(){
    //   $('.cdk-collection-tab .product-grid').slick({
    //     dots: false,
    //     infinite: true,
    //     centerMode: true,
    //     centerPadding: '295px',
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M0.292892 8.7071C-0.0976296 8.31658 -0.0976295 7.68341 0.292893 7.29289L6.65685 0.928929C7.04738 0.538404 7.68054 0.538404 8.07107 0.928929C8.46159 1.31945 8.46159 1.95262 8.07107 2.34314L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.7071ZM48 9L1 9L1 7L48 7L48 9Z" fill="#369FC6"/></svg></button>',
    //     nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M47.7071 8.7071C48.0976 8.31658 48.0976 7.68341 47.7071 7.29289L41.3431 0.928929C40.9526 0.538404 40.3195 0.538404 39.9289 0.928929C39.5384 1.31945 39.5384 1.95262 39.9289 2.34314L45.5858 8L39.9289 13.6569C39.5384 14.0474 39.5384 14.6805 39.9289 15.0711C40.3195 15.4616 40.9526 15.4616 41.3431 15.0711L47.7071 8.7071ZM8.74228e-08 9L47 9L47 7L-8.74228e-08 7L8.74228e-08 9Z" fill="#369FC6"/></svg></button>',
    //     responsive: [
    //       {
    //         breakpoint: 1441,
    //         settings: {
    //           centerPadding: '200px',
    //           slidesToShow: 3,
    //           slidesToScroll: 1,
    //           infinite: true,
    //           dots: false
    //         }
    //       },
    //       {
    //         breakpoint: 1100,
    //         settings: {
    //           centerMode: true,
    //           centerPadding: '200px',
    //           slidesToShow: 2,
    //           slidesToScroll: 1,
    //           infinite: true,
    //           dots: false
    //         }
    //       },
    //       {
    //         breakpoint: 991,
    //         settings: {
    //           centerMode: true,
    //           centerPadding: '200px',
    //           slidesToShow: 1,
    //           slidesToScroll: 1,
    //           centerMode: true,
    //           dots:true,
    //           arrows: false
    //         }
    //       },
    //       {
    //         breakpoint: 767,
    //         settings:"unslick",
    //       }
    //     ]
    //   });
    // }
    $(".cdesk-cart-drawer .cart-item__quantity-wrapper .quantity__input").change(function () {
      setTimeout(function () {   
        youMayLikeCartSlider()
      },2500);
    })

     $(document).on("click",".header__icon--cart",function () {
      setTimeout(function () { 
        reccentCartSlider();
        youMayLikeCartSlider();        
      },500);
    });

    $(document).on("click",".cart-remove-button",function () {
      console.log("click");
      setTimeout(function () { 
        reccentCartSlider();
        youMayLikeCartSlider();        
      },1500);
    });

   // Homepage aticle slider 
  $('.cdk-featured-blog-slider:not(.article-blog-slider)').slick({
    dots: false,
    infinite: true,
    centerMode: true,
    centerPadding: '296px',
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<div class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M0.292892 8.7071C-0.0976296 8.31658 -0.0976295 7.68341 0.292893 7.29289L6.65685 0.928929C7.04738 0.538404 7.68054 0.538404 8.07107 0.928929C8.46159 1.31945 8.46159 1.95262 8.07107 2.34314L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.7071ZM48 9L1 9L1 7L48 7L48 9Z" fill="#369FC6"/></svg></button>',
    nextArrow: '<div class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M47.7071 8.7071C48.0976 8.31658 48.0976 7.68341 47.7071 7.29289L41.3431 0.928929C40.9526 0.538404 40.3195 0.538404 39.9289 0.928929C39.5384 1.31945 39.5384 1.95262 39.9289 2.34314L45.5858 8L39.9289 13.6569C39.5384 14.0474 39.5384 14.6805 39.9289 15.0711C40.3195 15.4616 40.9526 15.4616 41.3431 15.0711L47.7071 8.7071ZM8.74228e-08 9L47 9L47 7L-8.74228e-08 7L8.74228e-08 9Z" fill="#369FC6"/></svg></button>',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          centerMode: true,
          centerPadding: '150px',
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 991,
        settings: {
          centerMode: true,
          centerPadding: '120px',
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false 
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
         centerMode: true,
          centerPadding: '40px',
          dots:true,
          arrows: false 
        }
      }
    ]
  });





  $('.article-blog-slider').slick({
    dots: false,
    infinite: false,
    centerMode: true,
    centerPadding: '75px',
    variableWidth: false,
    slidesToShow: 3.2,
    slidesToScroll: 1,
    
    cssEase: 'linear',
    prevArrow: '<div class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M0.292892 8.7071C-0.0976296 8.31658 -0.0976295 7.68341 0.292893 7.29289L6.65685 0.928929C7.04738 0.538404 7.68054 0.538404 8.07107 0.928929C8.46159 1.31945 8.46159 1.95262 8.07107 2.34314L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.7071ZM48 9L1 9L1 7L48 7L48 9Z" fill="#369FC6"/></svg></button>',
    nextArrow: '<div class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M47.7071 8.7071C48.0976 8.31658 48.0976 7.68341 47.7071 7.29289L41.3431 0.928929C40.9526 0.538404 40.3195 0.538404 39.9289 0.928929C39.5384 1.31945 39.5384 1.95262 39.9289 2.34314L45.5858 8L39.9289 13.6569C39.5384 14.0474 39.5384 14.6805 39.9289 15.0711C40.3195 15.4616 40.9526 15.4616 41.3431 15.0711L47.7071 8.7071ZM8.74228e-08 9L47 9L47 7L-8.74228e-08 7L8.74228e-08 9Z" fill="#369FC6"/></svg></button>',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          centerMode: true,
          // centerPadding: '150px',
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 991,
        settings: {
          centerMode: true,
          // centerPadding: '120px',
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false 
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
         centerMode: true,
         //  centerPadding: '40px',
          dots:true,
          arrows: false 
        }
      }
    ]
  });
 $(".video-list-wrapper,.mobile_slider_blog").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    infinite: false,
    autoplaySpeed: 5000,
    autoplay: false,
    swipeToSlide: true,
    prevArrow: '<div class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M0.292892 8.7071C-0.0976296 8.31658 -0.0976295 7.68341 0.292893 7.29289L6.65685 0.928929C7.04738 0.538404 7.68054 0.538404 8.07107 0.928929C8.46159 1.31945 8.46159 1.95262 8.07107 2.34314L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.7071ZM48 9L1 9L1 7L48 7L48 9Z" fill="#369FC6"/></svg></button>',
    nextArrow: '<div class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="16" viewBox="0 0 48 16" fill="none"><path d="M47.7071 8.7071C48.0976 8.31658 48.0976 7.68341 47.7071 7.29289L41.3431 0.928929C40.9526 0.538404 40.3195 0.538404 39.9289 0.928929C39.5384 1.31945 39.5384 1.95262 39.9289 2.34314L45.5858 8L39.9289 13.6569C39.5384 14.0474 39.5384 14.6805 39.9289 15.0711C40.3195 15.4616 40.9526 15.4616 41.3431 15.0711L47.7071 8.7071ZM8.74228e-08 9L47 9L47 7L-8.74228e-08 7L8.74228e-08 9Z" fill="#369FC6"/></svg></button>',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.3,
        },
      },
      {
        breakpoint: 767,
        settings: {
        infinite: true,
        centerMode: true,
        centerPadding: "56.5px",
        slidesToShow: 1,
        arrows: false 
        },
      },
    ],
  });

  $('.logo_slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
            dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.logo-with-text-wrapper').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 0,
    speed: 6000,
    slidesToShow: 4.5,
    slidesToScroll: 1,
    cssEase: 'linear',
    pauseOnHover: false,
    draggable: false,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
            dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
    // article read more
   
  customTabSilder();
  setTimeout(function () {
    reccentCartSlider();  
    // youMayLikeCartSlider();
  }, 1500);


  $(".cdk_product_slider").slick({
      autoplay: false,
      autoplaySpeed: 6000,
      infinite: true,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      focusOnSelect: true,
      asNavFor: ".cdk_product_thumb",
      adaptiveHeight: true,
      prevArrow: '<button class="slide-arrow prev-arrow"><svg width="25px" height="25px" viewBox="-2 0 20 20" version="1.1" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <g id="Free-Icons" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"> <g transform="translate(-825.000000, -674.000000)" id="Group" stroke="#01ABCC" stroke-width="1.5"> <g transform="translate(819.000000, 672.000000)" id="Shape"> <polyline points="17.0011615 3 7 12.0021033 17.0011615 21.0042067"> </polyline> </g> </g> </g> </g></svg></button>',
      nextArrow: '<button class="slide-arrow next-arrow"><svg width="25px" height="25px" viewBox="-6 0 20 20" version="1.1" fill="#000000" stroke="#000000" style="&#10;"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <g id="Free-Icons" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"> <g transform="translate(-751.000000, -674.000000)" id="Group" stroke="#01ABCC" stroke-width="1.5"> <g transform="translate(745.000000, 672.000000)" id="Shape"> <polyline points="7 3 17.0011615 12.0021033 7 21.0042067"> </polyline> </g> </g> </g> </g></svg></button>',
  });

    $(".cdk_product_thumb").slick({
      dots: false,
      autoplay: false,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      asNavFor: ".cdk_product_slider",
      centerMode: false,
      focusOnSelect: true,
      centerPadding: "20px",
      variableWidth: true,  
    });
    $(window).on("resize", function() {
      $(".cdk_product_slider, .cdk_product_thumb").slick("resize");
    });

    $(document).on("click" , '.cdk-tabs-work', function(){
      var dataTab = $(this).attr('data-tab');
      console.log("dataTab::"+dataTab);
      $('.cdk_tab_content').removeClass('active').hide();
      $(".cdk-tabs-work").removeClass("active");
      $(".cdk_tab_content[data-content= '" +dataTab+ "' ]").addClass('active').show();
      $(".cdk-tabs-work[data-tab= '" +dataTab+ "' ]").addClass("active"); 
      $(".cdk_tab_content.active").flickity('destroy');
      customTabSilder();
    });


  $(document).on("click" , '.cdk-tabs-work', function(){
      var dataTab = $(this).attr('data-tab');
      console.log("dataTab::"+dataTab);
      $('.cdk_faq_tab_content').removeClass('active').hide();
      $(".cdk-tabs-work").removeClass("active");
      $(".cdk_faq_tab_content[data-content= '" +dataTab+ "' ]").addClass('active').show();
      $(".cdk-tabs-work[data-tab= '" +dataTab+ "' ]").addClass("active"); 
    });




  
    $(document).on("click" , '.text-link', function(){
      var dataTab = $(this).attr('data-tab');
      console.log("dataTab::"+dataTab);
      $(this).addClass('active');
      $(this).siblings('.text-link').removeClass('active');
      $(".cdk-collection-tab").siblings('.cdk-collection-tab').hide(); 
      $(".cdk-collection-tab[data-tab= '" +dataTab+ "' ]").show();
      $('.cdk-slick-slider,.cdk-collection-tab .product-grid').slick('destroy');
      setTimeout(function () {
        collectionTabs();
        // wholeSaleCollectionTabsilder();
      }, 100);
    });

  $(document).on("click",'.cdk_custom_add:not(.freeGiftProduct)[data-btn="addToCart"], .cdk-addToCart:not(.freeGiftProduct)',function () {
    var currentThis = $(this);
    var updateItems = [];
    var variantId = $(this).attr("data-variant");
    var quantity = 1;
    updateItems.push({ id: variantId, quantity: quantity });
    ajaxAddToCartProduct(currentThis, updateItems);
    currentThis.addClass("is-loading");
    currentThis.find(".loading-overlay__spinner").removeClass("hidden");
    currentThis.find(".btn_text").addClass("hidden");
    $('.cdesk-cart-drawer').addClass('cdkCart-wrapper');
    setTimeout(function () {   
      youMayLikeCartSlider()
    },2500);
  });

   
  collectionTabs();  
  // wholeSaleCollectionTabsilder();
  $(window).on("resize", function() {
    $(".cdk-slick-slider,.cdk-collection-tab .product-grid").slick("resize");
  });
  
  // $(document).on("click" , '.drawer__inner-empty .cart-drawer__collections .quick-view-wrapper .cdk--button', function(){
  //   setTimeout(function () {   
  //     $(".drawer__inner-empty").hide();
  //     $(".drawer__header, .cart_drawer_scroll").css("display","flex");
  //     $(".drawer__footer").show();
  //   },500);
  // });
  
  $(document).on('click', '.next-btn', function(){
    $('.cdk-featured-blog-slider .next-arrow').click();
  });
    $(document).on('click', '.prev-btn', function(){
    $('.cdk-featured-blog-slider .prev-arrow').click();
  });


// Function to run when the page loads
  checkWindowSize();

  // Function to run when the window is resized
  $(window).on('resize', function() {
    checkWindowSize();
  });

  
})


function checkWindowSize() {
  var windowWidth = $(window).width();


  if (windowWidth >= 1280) {
    var isFlickity = true;
    if ( isFlickity ) {
      // destroy Flickity
      $(".collection_filter_wrapper:not(.all-glass)").flickity('destroy');
    }
    isFlickity = !isFlickity;
  } else {
    
    $(".collection_filter_wrapper:not(.all-glass)").flickity({
      wrapAround: true,
      pageDots: true,
      cellAlign: 'left',
      initialIndex: 0,
      accessibility: true, 
      prevNextButtons: true,
      freeScroll: true,
      autoPlay: false
    });
  }
}

$(".collection_filter_wrapper.all-glass").flickity({
  wrapAround: true,
  pageDots: true,
  cellAlign: 'left',
  initialIndex: 0,
  accessibility: true, 
  prevNextButtons: true,
  freeScroll: true,
  autoPlay: false
});

// function checkWindowSize() {
//   var windowWidth = $(window).width();


//     if (windowWidth >= 1500) {
//       var isFlickity = true;
//       if ( isFlickity ) {
//         // destroy Flickity
//         $(".collection_filter_wrapper.all-glass").flickity('destroy');
//       }
//       isFlickity = !isFlickity;
      
//     } else if (windowWidth >= 1100) {
      
//       var isFlickity = true;
//       if ( isFlickity ) {
//         // destroy Flickity
//         $(".collection_filter_wrapper.all-plastic").flickity('destroy');
//       }
//       isFlickity = !isFlickity;
      
//     } else if (windowWidth >= 1080) {
      
//       var isFlickity = true;
//       if ( isFlickity ) {
//         // destroy Flickity
//         $(".collection_filter_wrapper.all").flickity('destroy');
//       }
//       isFlickity = !isFlickity;
      
//     }else {
      
//       $(".collection_filter_wrapper").flickity({
//         wrapAround: true,
//         pageDots: true,
//         cellAlign: 'left',
//         initialIndex: 0,
//         accessibility: true, 
//         prevNextButtons: true,
//         freeScroll: true,
//         autoPlay: false
//       });
//     }
//   }

//   // Function to run when the page loads
//   checkWindowSize();

//   // Function to run when the window is resized
//   $(window).on('resize', function() {
//     checkWindowSize();
//   });

$(document).ready(function(){

  // Store references to sliders 
  var $mainSlider = $('.cdk_product_slider'); 
  var $modalSlider = $('.cdk-product .product-media-modal .product-media-modal__content');
  
  // Reusable function to stop vides  
  var stopVideos = function() {
    $('iframe').each(function() {
      $(this)[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*'); 
    });
  }
  
  // Main slider init
  $mainSlider.on('init afterChange', function(event, slick) {
    stopVideos();
  });
  
  // Modal slider init 
  $modalSlider.on('init afterChange', function(event, slick) {
    stopVideos();  
  });
  
  // Handle click event
  // $mainSlider.find('.slider__slide').click(function() {    
  //   var index = $(this).data('slick-index');
  //   $modalSlider.slick('slickGoTo', index); 
  // });
  
  // Initialize slick
  // $mainSlider.slick(); 
  // $modalSlider.slick();

   $(".cdk-product .product-media-modal .product-media-modal__content").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      // Synchronize the second slider with the first slider
      $(".cdk_product_slider").slick("slickGoTo", nextSlide);
    });
    
    $(".cdk_product_slider").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      // Synchronize the first slider with the second slider
      $('.cdk-product .product-media-modal .product-media-modal__content').slick("slickGoTo", nextSlide);
    });
  
  
});